import { ArrowRight, CircleDot } from "lucide-react";
import { Reveal } from "@/lib/reveal";
import { SectionMarker } from "@/components/SectionMarker";
import { handleAnchorClick } from "@/lib/scroll";

export const AidFeature = () => {
  return (
    <section id="a-id" className="relative py-20 lg:py-32" data-testid="aid-feature-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div>
            <Reveal>
              <SectionMarker n="02" label="A-ID" />
              <div className="mt-6 flex items-baseline gap-4 flex-wrap">
                <span className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight text-gradient-teal">
                  A-ID
                </span>
                <span className="font-display text-lg sm:text-xl font-semibold uppercase tracking-[0.14em] text-white">
                  Your digital accessibility identity
                </span>
              </div>
              <p className="mt-4 font-display text-2xl sm:text-3xl font-bold text-white">
                One identity. Many journeys. Your control.
              </p>
            </Reveal>

            <Reveal delay={0.08}>
              <p className="mt-6 text-lg text-slate-200 leading-relaxed">
                A-ID brings your accessibility information together in one place, so you can
                choose what information is relevant to each journey and control how it is shared.
              </p>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-4 text-lg text-slate-300 leading-relaxed">
                A-ID is being developed to help reduce the need for people to repeatedly explain
                their accessibility needs across different situations.
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-teal/30 bg-teal/5 px-4 py-2 text-sm font-medium text-teal">
                <CircleDot className="h-4 w-4" aria-hidden="true" />
                Currently being developed and prepared for early testing
              </div>
            </Reveal>

            <Reveal delay={0.26}>
              <div className="mt-8">
                <a
                  href="#how"
                  onClick={(e) => handleAnchorClick(e, "#how")}
                  className="group inline-flex items-center justify-center gap-2 rounded-full bg-teal px-7 py-4 text-base font-semibold text-navy-900 hover:bg-cyan transition-colors shadow-[0_0_30px_-6px_rgba(0,240,255,0.6)]"
                  data-testid="explore-aid-btn"
                >
                  Explore A-ID
                  <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
